import { useAuth } from '../pages/login/OAuth';

const useProviderService = () => {
    const { api } = useAuth();

    const getProvider = (id) =>
        api().get(`/providers/${id}`);

    const getProviders = (params) =>
        api().get('/providers/', { params });

    const createProvider = (data) =>
        api().post('/providers/new', data);

    const updateProvider = (data) =>
        api().patch('/providers/update', data);

    const disableProvider = (id) =>
        api().patch('/providers/disable', { provider_id: id });

    return {
        getProvider,
        getProviders,
        createProvider,
        updateProvider,
        disableProvider,
    };
};

export default useProviderService;
